import Button from '#lib/components/button.jsx';
import { LoadingIndicator } from '#lib/components/loading.jsx';
import { addClasses } from '#lib/helpers/class.js';
import { findActivePackage, PackagesIDs, premiumPackages } from '#routes/settings/billing/billing-helpers.js';
import { usePack, usePurchases } from '#src/@billing/use-billing.js';
import { Icon } from '@iconify-icon/react';
import { Link } from 'react-router-dom';

export default function PackageCard() {
    const { data: packages, isLoading: packsLoading } = usePack();
    const { data: purchases, isLoading: purchasesLoading } = usePurchases();

    const activePackage =
        Array.isArray(purchases) && Array.isArray(packages) ? findActivePackage(purchases, packages) : null;
    const packageType = activePackage ? activePackage.packageId : '';

    if (packsLoading || purchasesLoading)
        return (
            <div className="h-[340px] md:h-[300px] w-full md:w-1/2 flex justify-center items-center md:shadow-lg rounded-lg md:rounded-xl">
                <LoadingIndicator />
            </div>
        );

    const isExpiring = new Date(activePackage?.dateExpire) - new Date() < 604800000;
    const isWelcomePackage = activePackage?.packageId === PackagesIDs.WELCOME;
    return (
        <>
            <div className="h-[340px] md:h-[300px] rounded-lg w-full md:w-1/2 flex flex-col justify-between p-2 md:shadow-lg md:rounded-xl border-b border-b-neutral-200 md:border-none">
                <div className="flex flex-col gap-4">
                    <p className="text-lg font-bold text-neutral-800">{_t.profile.activePackageTitle()}</p>
                    <b>{_t.profile.packageTypeInfo(packageType)}</b>
                    <div className="flex flex-col text-sm md:text-md">
                        <div key="users" className="flex items-center gap-2 py-1">
                            <Icon icon="material-symbols:groups-outline" width={'1.2rem'} height={'1.2rem'} />
                            <p>{_t.package.users(packageType)}</p>
                        </div>
                        <div key="itineraries" className="flex items-center gap-2 py-1">
                            <Icon icon="bx:trip" width={'1.2rem'} height={'1.2rem'} />
                            <p>{_t.package.itineraries(packageType)}</p>
                        </div>
                        {premiumPackages.includes(packageType) && (
                            <div key="premium" className="flex items-center gap-2 py-1">
                                <Icon icon="ic:outline-workspace-premium" width={'1.2rem'} height={'1.2rem'} />
                                <p>{_t.package.premium(packageType)}</p>
                            </div>
                        )}
                    </div>
                    <div className="flex items-baseline gap-2 text-sm md:text-md">
                        {!isExpiring && !isWelcomePackage ? (
                            <>
                                <span className="text-sm italic">{_t.profile.expireDateInfo()}</span>
                                <span>{activePackage?.expireDate ?? ''}</span>
                            </>
                        ) : (
                            <p> {_t.home.buyMorePackages()} </p>
                        )}
                    </div>
                </div>
                <Link className="w-fit my-2 md:my-0" to="/settings/billing">
                    <Button look="primary">
                        {_t.home.goToBilling()}
                        <Icon icon="line-md:arrow-small-right" width="1.4rem" height="1.4rem" className="ml-2 pt-1" />
                    </Button>
                </Link>
            </div>
        </>
    );
}
